// Author YuJiaBei
// Date 2022-04-22 16:27:57

class InspectionWorkOrder {
constructor({
        id = null,
        startTime = '',
        executor = '',
        inspectionScheduleId = ''}
= {}) {
    this.id = id;
    this.startTime = startTime;
    this.executor = executor;
    this.inspectionScheduleId = inspectionScheduleId;
}
}

function newEntity() {
return new InspectionWorkOrder();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'workOrderCode',
        label: 'label.em.inspection.inspectionWorkOrder.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deptName',
        label: 'label.em.inspection.inspectionWorkOrder.grid.deptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'executorRealName',
        label: 'label.em.inspection.inspectionWorkOrder.grid.executorRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionScheduleName',
        label: 'label.em.inspection.inspectionWorkOrder.grid.inspectionScheduleName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionCategoryName',
        label: 'label.em.inspection.inspectionWorkOrder.grid.inspectionCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.inspection.inspectionWorkOrder.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.em.inspection.inspectionWorkOrder.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'executeTime',
        label: 'label.em.inspection.inspectionWorkOrder.grid.executeTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    inspectionScheduleIdFilter : '',
    bdaCodeFilter : '',
    deptNameFilter : '',
    inspectionTypeFilter : '',
    inspectionScheduleIdInFilter : [],
    executorNameFilter : '',
    executorFilter : '',
    workOrderCodeFilter : '',
    statusFilter : '',
    createdTimeGreatThanFilter : '',
    createdTimeLessThanFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'inspectionScheduleIdFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.inspectionScheduleId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'bdaCodeFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.bdaCode',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'deptNameFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.deptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionTypeFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.inspectionType',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'executorNameFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.executorName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"executor":"loginName"}'
                }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'InspectionWorkOrder',statusFilter:1}
        }
        },
        {
        key: 'createdTimeGreatThanFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.createdTimeGreatThan',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLessThanFilter',
        label: 'label.em.inspection.inspectionWorkOrder.filter.createdTimeLessThan',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'startTime',
        label: 'label.em.inspection.inspectionWorkOrder.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executor',
        label: 'label.em.inspection.inspectionWorkOrder.entity.executor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionScheduleId',
        label: 'label.em.inspection.inspectionWorkOrder.entity.inspectionScheduleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        }
]

export {InspectionWorkOrder, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
